import React, { useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { Link, useParams } from 'react-router-dom'
import UserImage from "../assets/user.png"
import { api } from '../app/Api/ApiSlice'
import { toast } from 'react-toastify'

const AddAdminCard = ({user}) => {
    const [isLoading,setIsLoading] = useState(false)
    const {organization} = useParams()

     const addAdmin = async () => {
            try {
                setIsLoading(true)
                const response = await api.post(`/${organization}/admins`, { id:user._id })
                toast.success(response.data.message)
                setIsLoading(false)
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }
  return (
      <div className="admin-card-container">
            <Link to={`/user/${user._id}`}>
                <div className="admin-card-details">
                    <div className="admin-card-profile-image">
                        <img src={user?.profilePic ? user.profilePic.url : UserImage} alt='' />
                    </div>
                    <div className="user-profile-name">
                        <p className=''>{user?.firstname} {user?.lastname}</p>
                    </div>
                </div>
            </Link>
            <div className="admin-chat-btn" onClick={addAdmin}>
                <FaPlus /> <p>{isLoading?"...":"Add"}</p>
            </div>
        </div >
  )
}

export default AddAdminCard